/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';
import LocalizedMessage from "../common/LocalizedMessage";
import Input from "../common/Input";
import Checkbox from "../common/Checkbox";
import SelectInput from "../common/SelectInput";
import {calculateDisplayedErrors} from "../common/Helpers";

const getLessonReminderPreference = lessonReminders => {
  if (!lessonReminders.enabled) return "none";
  return lessonReminders.firstLessonOnly ? "first" : "all";
};

function ClientForm({firstName, lastName, email, mobile, dataProcessingAgreement, sendNotifications, hasContract, invoiceData, touched, errors,
  showInvoiceData, contractDate, address, notes, lessonReminders, paymentReminders, notificationConsent, onShowInvoiceClick, onNotificationHistoryClick, onBlur, onChange, onSubmit, disabled, status, archived }) {
  const { t: tr } = useTranslation();
  const [notificationSettingsOpen, setNotificationSettingsOpen] = useState(false);
  const err = calculateDisplayedErrors(errors, touched, status);
  const lessonReminderControlsReadOnly = !sendNotifications || !!lessonReminders.optedOutAt;
  const paymentReminderControlsReadOnly = !sendNotifications || !!paymentReminders.optedOutAt;
  const lessonReminderPreference = getLessonReminderPreference(lessonReminders);
  return (
    <div>
      <h2 className="manage-title">{tr("manage:client_108")}</h2>
      <form id="client-form" onSubmit={onSubmit}>
        <fieldset disabled={archived}>
          <div className="form-row">
            <div className="col-md-6">
              <Input label={tr("common:firstName")} onBlur={onBlur} onChange={onChange} name="firstName" value={firstName} error={err.firstName} placeholder={tr("common:firstName")} />
            </div>
            <div className="col-md-6">
              <Input label={tr("common:lastName")} onBlur={onBlur} onChange={onChange} name="lastName" value={lastName} error={err.lastName} placeholder={tr("common:lastName")} />
            </div>
          </div>

          <div className="form-row">
            <div className="col-md-6">
              <Input label={tr("manage:emailOptional_109")} onBlur={onBlur} onChange={onChange} name="email" value={email || ''} error={err.email} placeholder={tr("common:email")} />
            </div>
            <div className="col-md-6">
              <Input label={tr("manage:phoneOptional_110")} onBlur={onBlur} onChange={onChange} name="mobile" value={mobile || ''} error={err.mobile} placeholder={tr("manage:phoneNumber_111")} />
            </div>
          </div>

          <div className="form-row  ">
            <div className="col-md-6">
              <Checkbox label={tr("manage:gdprConsent_112")} onBlur={onBlur} onChange={onChange} name="dataProcessingAgreement" isChecked={dataProcessingAgreement} error={err.dataProcessingAgreement}/>
            </div>
          </div>

          <div className="form-row  d-flex align-items-center">
            <div className="col-md-6">
              <Checkbox label={tr("manage:signedAgreement_113")} onBlur={onBlur} onChange={onChange} name="hasContract" isChecked={hasContract} error={err.hasContract}/>
            </div>
            <div className="col-md-6">
              <Input type="date" label={tr("manage:agreementDate_114")} onBlur={onBlur} onChange={onChange} name="contractDate" value={contractDate} error={err.contractDate} placeholder={tr("manage:agreementDate_114")} />
            </div>
          </div>

          <section className="client-reminders-section" aria-label={tr("manage:notifications_115")}>
            <label className="client-reminders-toggle checkbox-label" htmlFor="client-send-notifications">
              <input
                id="client-send-notifications"
                className="client-reminders-checkbox mr-2"
                type="checkbox"
                name="sendNotifications"
                checked={sendNotifications}
                disabled={disabled}
                onBlur={onBlur}
                onChange={event => onChange({ target: { name: "sendNotifications", value: event.target.checked } })}
              />
              <strong>{tr("manage:sendNotifications_116")}</strong>
            </label>
            <button type="button" className="btn btn-sm manage-button manage-teal-button" disabled={disabled} aria-haspopup="dialog" onClick={() => setNotificationSettingsOpen(true)}>
              {tr("manage:notificationSettings.configure")}
            </button>
            {err.sendNotifications && <div className="text-danger"><LocalizedMessage isError value={err.sendNotifications} /></div>}
          </section>

          <div className="form-row ">
            <div className="col-md-12">
              <Input label={tr("manage:address_124")} onBlur={onBlur} onChange={onChange} name="address" value={address} error={err.address} placeholder={tr("manage:address_124")} />
            </div>
          </div>

          {!showInvoiceData && (
            <div className="row ">
              <div className="col-md-block ">
                <button type="button" className="btn btn-sm btn-link btn-block pl-3" disabled={disabled} onClick={onShowInvoiceClick}>{tr("manage:addInvoiceDetails_125")}</button>
              </div>
            </div>
          )}
          {showInvoiceData && (
            <div className="form-row ">
              <div className="col-md-12 " style={{minheight: "5em"}}>
                <Input label={tr("manage:invoiceDetails_126")} type="textarea" onBlur={onBlur} onChange={onChange} name="invoiceData" value={invoiceData} error={err.invoiceData} placeholder={tr("manage:invoiceDetails_126")} />
              </div>
            </div>
          )}

          <div className="form-row ">
            <div className="col-md-12">
              <Input label={tr("manage:notes_10")} onBlur={onBlur} onChange={onChange} name="notes" value={notes} error={err.notes} placeholder={tr("manage:notes_10")} />
            </div>
          </div>
        </fieldset>
      </form>
      <Modal
        show={notificationSettingsOpen}
        onHide={() => setNotificationSettingsOpen(false)}
        aria-labelledby="client-notification-settings-title"
        centered
        onEntered={node => { node.removeAttribute("aria-hidden"); node.setAttribute("aria-labelledby", "client-notification-settings-title"); }}
      >
        <Modal.Header closeButton closeLabel={tr("common:close")}>
          <Modal.Title id="client-notification-settings-title">{tr("manage:notificationSettings.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted">{tr("manage:notificationSettings.saveHint")}</p>
          {!sendNotifications && <p className="alert alert-info">{tr("manage:notificationSettings.disabledHint")}</p>}
          <fieldset disabled={archived || disabled}>
            <div className="form-row">
              <div className="col-md-12">
                <SelectInput
                  label={tr("manage:lessonNotifications_117")}
                  onChange={event => onChange({
                    ...event,
                    target: {
                      name: "lessonReminders.preference",
                      value: event.target.value,
                    },
                  })}
                  name="lessonReminders.preference"
                  value={lessonReminderPreference}
                  error={err["lessonReminders.preference"]}
                  readOnly={lessonReminderControlsReadOnly}
                  options={[
                    { value: "none", text: tr("manage:extraDoNotSend_18") },
                    { value: "first", text: tr("manage:extraBeforeTheFirstLesson_19") },
                    { value: "all", text: tr("manage:extraBeforeEveryLesson_20") },
                  ]}
                />
              </div>
              {lessonReminders.optedOutAt && (
                <div className="col-md-12">
                  <small className="text-muted">{tr("manage:theClientHasDisabledRemindersUsingTheLinkIn_118")}</small>
                  <button
                    type="button"
                    className="btn btn-sm btn-link pl-2"
                    disabled={disabled}
                    onClick={() => onChange({
                      target: {
                        name: "lessonReminders.restoreOptOut",
                        value: true,
                      },
                    })}
                  >{tr("manage:enableRemindersAgain_119")}
                  </button>
                </div>
              )}
              <div className="col-md-12">
                <Checkbox
                  label={tr("manage:paymentReminders_120")}
                  onBlur={onBlur}
                  onChange={onChange}
                  name="paymentReminders.enabled"
                  isChecked={paymentReminders.enabled}
                  readOnly={paymentReminderControlsReadOnly}
                  error={err["paymentReminders.enabled"]}
                />
                <small className="text-muted">{tr("manage:emailAfterSettlementApprovalAndOverdueRemindersAccordingTo_121")}</small>
              </div>
              {paymentReminders.optedOutAt && (
                <div className="col-md-12">
                  <div className="alert alert-warning mb-2" role="alert">{tr("manage:theClientHasUnsubscribedFromPaymentRemindersAnOperator_122")}</div>
                </div>
              )}
              {onNotificationHistoryClick && (
                <div className="col-md-12">
                  <button
                    type="button"
                    className="btn btn-sm btn-link pl-0"
                    disabled={disabled}
                    onClick={() => {
                      setNotificationSettingsOpen(false);
                      onNotificationHistoryClick();
                    }}
                  >{tr("manage:notificationHistory_123")}
                  </button>
                </div>
              )}
            </div>

            {notificationConsent}
          </fieldset>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn manage-button manage-teal-button" onClick={() => setNotificationSettingsOpen(false)}>{tr("common:back")}</button>
        </Modal.Footer>
      </Modal>


    </div>
  );
}

ClientForm.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  mobile: PropTypes.string,
  dataProcessingAgreement: PropTypes.bool,
  hasContract: PropTypes.bool,
  sendNotifications: PropTypes.bool,
  contractDate: PropTypes.string,
  address: PropTypes.string,
  notes: PropTypes.string,
  invoiceData: PropTypes.string,
  lessonReminders: PropTypes.shape({
    enabled: PropTypes.bool,
    channel: PropTypes.string,
    firstLessonOnly: PropTypes.bool,
    optedOutAt: PropTypes.string,
    lastSentAt: PropTypes.string,
  }),
  paymentReminders: PropTypes.shape({
    enabled: PropTypes.bool,
    channel: PropTypes.string,
    optedOutAt: PropTypes.string,
    lastSentAt: PropTypes.string,
  }),
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onShowInvoiceClick: PropTypes.func.isRequired,
  onNotificationHistoryClick: PropTypes.func,
  notificationConsent: PropTypes.node,
  onSubmit: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  showInvoiceData: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  archived: PropTypes.bool,
};

ClientForm.defaultProps = {
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
  dataProcessingAgreement: false,
  hasContract: false,
  sendNotifications: false,
  contractDate: "",
  address: "",
  notes: "",
  invoiceData: "",
  lessonReminders: {
    enabled: false,
    channel: "email",
    firstLessonOnly: true,
    optedOutAt: null,
    lastSentAt: null,
  },
  paymentReminders: {
    enabled: true,
    channel: "email",
    optedOutAt: null,
    lastSentAt: null,
  },
  disabled: false,
  archived: false,
  onNotificationHistoryClick: null,
  notificationConsent: null,
};

export default ClientForm;
